import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

import OrderEntryModel from 'models/OrderEntryModel';
import { initialResultsDtoModel, ResultsDtoModel } from 'models/ResultsDtoModel';
import SearchTransactionDto from 'models/SearchTransactionDto';

import { getAuthorizedApi, processAxiosError, urlBuilder } from "services/common.service";
import { setResultsDtoBase } from "reducers/dto.slice";


export const getOrders = createAsyncThunk('orders/getOrders',
    async (searchDto: SearchTransactionDto, { dispatch }) => {
        try {
            const url = urlBuilder('/Orders/GetOrders', searchDto);

            const response = await getAuthorizedApi().get<ResultsDtoModel<OrderEntryModel>>(url);

            const data = response.data;

            dispatch(setResultsDtoBase({
                totalResults: data.totalResults,
                offset: data.offset,
                page: data.page
            }));

            return data;
        } catch (err) {
            const error = err as AxiosError;
            processAxiosError(error, dispatch);
        }
        return initialResultsDtoModel;
    });